var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: !_vm.showSocialPlanDetails,
          expression: "!showSocialPlanDetails"
        }
      ],
      staticClass: "pb-0 group-title-wrapper"
    },
    [
      _c("div", { staticClass: "group-title" }, [
        _c("div", { staticClass: "group-title col-md-6" }, [
          _c(
            "h1",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.editTitle,
                  expression: "!editTitle"
                }
              ],
              staticClass:
                "mb-0 exclude-outside-click project-title edit-d-title cursor-pointer",
              on: { click: _vm.activateTitleField }
            },
            [_vm._v(_vm._s(_vm.deliverableDetail.title) + " ")]
          ),
          _vm._v(" "),
          _c("textarea", {
            directives: [
              {
                name: "click-outside",
                rawName: "v-click-outside",
                value: _vm.clickOutsideTitle,
                expression: "clickOutsideTitle"
              },
              {
                name: "show",
                rawName: "v-show",
                value: _vm.editTitle,
                expression: "editTitle"
              },
              {
                name: "model",
                rawName: "v-model",
                value: _vm.deliverableDetail.title,
                expression: "deliverableDetail.title"
              }
            ],
            ref: "editTitleRef",
            staticClass:
              "form-control mb-3 title-field exclude-outside-click h1",
            attrs: {
              type: "text",
              placeholder: _vm.getDeliverableTitlePlaceholder
            },
            domProps: { value: _vm.deliverableDetail.title },
            on: {
              change: _vm.updateDeliverableTitle,
              blur: function($event) {
                _vm.editTitle = false
              },
              input: function($event) {
                if ($event.target.composing) {
                  return
                }
                _vm.$set(_vm.deliverableDetail, "title", $event.target.value)
              }
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }